<template>
  <div id="wrapper">
    <SidebarView :journal="true" :add-opening-or-closing-journal="true" :journal-visible="true" />
    <div class="d-flex flex-column" id="content-wrapper">
      <div id="content">
        <TopbarView />
        <form @submit.prevent="submitJournal()" :add_or_edit="add_or_edit">
          <div class="mx-3">
            <div class="general-error d-flex justify-content-center">
              <errors v-if="form.message">
                {{ form.message }}
              </errors>
            </div>
            <div v-if="ledgerDifferenceBlockingError" class="alert alert-danger py-2 small">
              {{ ledgerDifferenceBlockingError }}
            </div>
            <div class="row mb-4">
              <div class="col-12 col-md-12">
                <div class="card card-shape home-box">
                  <div class="card-header pe-1 d-flex flex-row align-items-center justify-content-between">
                    <h6 class="m-0 fw-bold text-green">Year-End Account Closure/Opening</h6>
                    <button type="submit" :disabled="isSaving || autoZero.enabled" class="btn akkurate-green-btn text-white btn-size">
                      <font-awesome-icon class="me-2" :icon="['fas', 'save']" />{{ save }}
                    </button>
                  </div>
                  <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-4">
                            <label class="akkurate-dark" for="middle_name">Posting Type <star></star></label>
                            <b-form-group>
                                <multiselect v-model="form.journal_type" name="coa_subhead" :options="journal_type_options" @input="refreshAllBalances"
                                :disabled="autoZero.enabled"
                                class="mt-2 field-container" label="name" :custom-label="optionsLabel" required>
                                </multiselect>
                                <div v-if="autoZero.enabled" class="small text-muted mt-1">
                                  This posting is a year-end closure and will post as <strong>Closing</strong>.
                                </div>
                                <errors v-if="form.errors.journal_type">
                                {{ form.errors.journal_type[0] }}
                                </errors>
                            </b-form-group>
                        </div>

                        <div class="col-12 col-md-4">
                        <label class="akkurate-dark" for="recorded_date">Date<star></star></label>
                        <b-form-group id="recorded_date" label-for="recorded_date">
                            <b-form-input class="mb-3 mt-2 field-container fields" type="date" :disabled="edit_date_pemission || autoZeroDateLocked"
                            v-model="form.recorded_date" required></b-form-input>
                            <errors v-if="form.errors.recorded_date">
                            {{ form.errors.recorded_date[0] }}
                            </errors>
                        </b-form-group>
                        </div>

                        <div class="col-12 col-md-4">
                        <div class="d-flex">
                            <label class="akkurate-dark me-2" for="narration">Narration <star></star></label>
                            <!-- <b-form-checkbox id="checkbox-1" @change="desChecked" v-model="status" name="checkbox-1" value="accepted"
                            unchecked-value="not_accepted">
                            Apply for all
                            </b-form-checkbox> -->
                        </div>

                        <b-form-group id="narration" label-for="narration">
                            <b-form-textarea class="mt-2 fields" id="narration" placeholder="Enter Narration..."
                            v-model="form.narration"></b-form-textarea>
                            <errors v-if="form.errors.narration">
                            {{ form.errors.narration[0] }}
                            </errors>
                        </b-form-group>
                        </div>
                    </div>

                    <div class="row">
                      <div class="col-12" v-if="autoZero.enabled && !activeFY">
                        <div class="alert alert-warning py-2 small mb-2">
                          No active financial year. Activate one before using Auto Zero.
                        </div>
                      </div>

                      <div class="col-12" v-if="autoZero.enabled && activeFY">
                        <div class="alert alert-info py-2 small mb-2">
                          This posting dates are locked to ACTIVE FY:
                          <strong>{{ activeFY.start_date }}</strong> → <strong>{{ activeFY.end_date }}</strong>
                        </div>
                      </div>

                      <div class="col-12 col-md-6">
                        <label class="akkurate-dark">Ledger Difference GL</label>
                        <b-form-group>
                          <multiselect
                            v-model="form.ledger_difference_coa_subhead"
                            :options="coa_subhead_options"
                            class="mt-2 field-container"
                            label="name"
                            :custom-label="nameWithLang"
                            placeholder="Select Ledger Difference GL (recommended)"
                          />
                          <div class="small text-muted mt-1">
                            Used to automatically balance opening/closing entries when only a single debit/credit is posted.
                          </div>
                        </b-form-group>
                      </div>
                      <div class="col-12 col-md-6 mt-auto">
                        <div v-if="showLedgerDifferenceWarning" class="alert alert-warning py-2 small mb-0">
                          If entries don’t balance, posting will fail unless Ledger Difference GL exists.
                        </div>
                      </div>
                    </div>

                    <!-- <journal-form :form="form" :branch_options="branch_options"
                      @desChecked="updateStatus" :edit_date_pemission="edit_date_pemission"></journal-form> -->
                  </div>
                </div>
              </div>
            </div>

                    <!-- Financial Year-End Closure (FYT) -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card card-shape home-box">
                  <div class="card-header d-flex flex-row align-items-center justify-content-between">
                    <h6 class="m-0 fw-bold text-green">Financial Year-End Closure (zero´s Income and Expenses)</h6>
                    <b-form-checkbox v-model="autoZero.enabled">
                      Enable
                    </b-form-checkbox>
                  </div>
                  <div class="card-body">
                    <div class="small text-muted mb-2">
                      When enabled, the FYT posting will automatically zero all Income &amp; Expense COA subheads as an opening/closing balance (based on the selected Posting Type),
                      and post the balancing reserves lines (profit/loss) automatically.
                    </div>

                    <div v-if="autoZero.enabled">
                      <div v-if="autoZero.error" class="alert alert-danger py-2 small">{{ autoZero.error }}</div>

                              <div class="row">
                                <div class="col-12">
                                  <b-form-checkbox v-model="autoZero.generateOpeningStatement">
                                    Generate next year opening statement
                                  </b-form-checkbox>
                                  <div class="small text-muted mt-1">
                                    When enabled, the system will generate next year opening balances after closing.
                                  </div>
                                </div>
                              </div>

                      <div class="row mt-2">
                        <div class="col-12">
                          <b-form-checkbox v-model="autoZero.multiBranchEnabled" @change="onAutoZeroMultiBranchToggle">
                            Multi-branch Auto Closure
                          </b-form-checkbox>
                          <div class="small text-muted mt-1">
                            When enabled, you can configure reserve GLs per selected branch.
                          </div>
                        </div>
                      </div>

                      <div v-if="autoZero.multiBranchEnabled" class="mt-2">
                        <div class="row">
                          <div class="col-12 col-md-8">
                            <label class="akkurate-dark">Branches <star></star></label>
                            <b-form-group>
                              <multiselect
                                v-model="autoZero.selectedBranches"
                                :options="branchOptions"
                                label="name"
                                track-by="id"
                                :multiple="true"
                                :close-on-select="false"
                                class="mt-2 field-container"
                                placeholder="Select branches"
                                @input="onAutoZeroBranchesChanged"
                              />
                            </b-form-group>
                          </div>
                          <div class="col-12 col-md-4">
                            <label class="akkurate-dark">Copy config source</label>
                            <b-form-group>
                              <multiselect
                                v-model="autoZero.copySourceBranch"
                                :options="autoZero.selectedBranches"
                                label="name"
                                track-by="id"
                                class="mt-2 field-container"
                                placeholder="Select source branch"
                              />
                            </b-form-group>
                          </div>
                        </div>

                        <div class="d-flex flex-wrap gap-2 mt-2">
                          <button
                            type="button"
                            class="btn akkurate-grey-btn border-0 btn-size"
                            :disabled="autoZero.previewBusy || autoZero.applyBusy || !autoZero.copySourceBranch"
                            @click="copyAutoZeroConfigToAllBranches"
                          >
                            Copy config to all branches
                          </button>
                        </div>

                        <div v-if="autoZero.selectedBranches && autoZero.selectedBranches.length" class="table-responsive mt-3">
                          <table class="table table-bordered table-sm">
                            <thead>
                              <tr>
                                <th>Branch</th>
                                <th>Statutory Reserve GL</th>
                                <th>Operating Reserve GL</th>
                                <th>Loss Carryforward GL</th>
                                <th>Ledger Difference GL</th>
                                <th>Status</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="b in autoZero.selectedBranches" :key="b.id">
                                <td>
                                  <div class="fw-bold">{{ b.name }}</div>
                                  <div class="small text-muted">{{ b.code || '' }}</div>
                                </td>
                                <td style="min-width: 220px">
                                  <multiselect
                                    v-model="autoZero.branchRows[b.id].statutory"
                                    :options="coaSubheadsForBranch(b.id)"
                                    class="field-container"
                                    label="name"
                                    :custom-label="nameWithLang"
                                    @open="ensureCoaOptionsForBranch(b.id)"
                                  />
                                </td>
                                <td style="min-width: 220px">
                                  <multiselect
                                    v-model="autoZero.branchRows[b.id].operating"
                                    :options="coaSubheadsForBranch(b.id)"
                                    class="field-container"
                                    label="name"
                                    :custom-label="nameWithLang"
                                    @open="ensureCoaOptionsForBranch(b.id)"
                                  />
                                </td>
                                <td style="min-width: 220px">
                                  <multiselect
                                    v-model="autoZero.branchRows[b.id].loss"
                                    :options="coaSubheadsForBranch(b.id)"
                                    class="field-container"
                                    label="name"
                                    :custom-label="nameWithLang"
                                    @open="ensureCoaOptionsForBranch(b.id)"
                                  />
                                </td>
                                <td style="min-width: 220px">
                                  <multiselect
                                    v-model="autoZero.branchRows[b.id].ledgerDiff"
                                    :options="coaSubheadsForBranch(b.id)"
                                    class="field-container"
                                    label="name"
                                    :custom-label="nameWithLang"
                                    @open="ensureCoaOptionsForBranch(b.id)"
                                  />
                                  <div v-if="branchLedgerDiffMissing(b.id)" class="small text-warning mt-1">
                                    Recommended
                                  </div>
                                </td>
                                <td>
                                  <span
                                    class="badge"
                                    :class="branchValidation(b.id).ok ? 'bg-success' : 'bg-danger'"
                                  >
                                    {{ branchValidation(b.id).ok ? 'Ready' : 'Not ready' }}
                                  </span>
                                  <div v-if="!branchValidation(b.id).ok" class="small text-muted mt-1">
                                    {{ branchValidation(b.id).message }}
                                  </div>
                                </td>
                                <td class="text-end">
                                  <button
                                    type="button"
                                    class="btn akkurate-grey-btn border-0 btn-size"
                                    @click="clearAutoZeroBranchRow(b.id)"
                                  >
                                    Clear
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div v-if="autoZero.multiBranchResults && autoZero.multiBranchResults.length" class="mt-3">
                          <div class="fw-bold mb-2">Results</div>
                          <div class="table-responsive">
                            <table class="table table-bordered table-sm">
                              <thead>
                                <tr>
                                  <th>Branch</th>
                                  <th class="text-end">Net (Income − Expense)</th>
                                  <th>Status</th>
                                  <th>Message</th>
                                  <th>Opening posted_count</th>
                                  <th>Opening date</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(r, idx) in autoZero.multiBranchResults" :key="idx">
                                  <td>{{ branchNameById(r.branch_id) }}</td>
                                  <td class="text-end">{{ displayNumber(r.net_income_minus_expense) }}</td>
                                  <td>{{ r.status || '-' }}</td>
                                  <td>{{ r.message || '-' }}</td>
                                  <td>{{ r.opening_posted_count ?? r.posted_count ?? '-' }}</td>
                                  <td>{{ r.opening_date ?? '-' }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <div class="row" v-if="!autoZero.multiBranchEnabled">
                        <div class="col-12 col-md-4">
                          <label class="akkurate-dark">Statutory Reserve GL <star></star></label>
                          <b-form-group>
                            <multiselect v-model="autoZero.statutoryReserve" :options="coa_subhead_options"
                              class="mt-2 field-container" label="name" :custom-label="nameWithLang" required />
                          </b-form-group>
                        </div>

                        <div class="col-12 col-md-4">
                          <label class="akkurate-dark">Operating Reserve GL <star></star></label>
                          <b-form-group>
                            <multiselect v-model="autoZero.operatingReserve" :options="coa_subhead_options"
                              class="mt-2 field-container" label="name" :custom-label="nameWithLang" required />
                          </b-form-group>
                        </div>

                        <div class="col-12 col-md-4">
                                  <label class="akkurate-dark">Loss Carryforward GL</label>
                          <b-form-group>
                            <multiselect v-model="autoZero.lossCarryforward" :options="coa_subhead_options"
                                      class="mt-2 field-container" label="name" :custom-label="nameWithLang" />
                          </b-form-group>
                        </div>
                      </div>

                              <div class="small text-muted mt-1">
                                Profit: 25% → Statutory Reserve, 75% → Operating Reserve. Loss: → Loss Carryforward.
                              </div>

                      <div class="d-flex flex-wrap gap-2 mt-2">
                        <button type="button" class="btn akkurate-grey-btn border-0 btn-size"
                          :disabled="autoZero.previewBusy || autoZero.applyBusy" @click="previewAutoZero">
                          <b-spinner v-if="autoZero.previewBusy" small class="me-1"></b-spinner>
                          Preview
                        </button>
                        <button type="button" class="btn akkurate-green-btn text-white btn-size"
                          :disabled="!autoZeroCanApply || autoZero.previewBusy || autoZero.applyBusy || (autoZero.multiBranchEnabled && autoZero.multiBranchForbidden)"
                          @click="openAutoZeroConfirm">
                          <b-spinner v-if="autoZero.applyBusy" small class="me-1"></b-spinner>
                          Apply / Post
                        </button>
                      </div>

                      <div v-if="autoZero.preview" class="mt-3">
                        <div class="d-flex flex-wrap justify-content-between align-items-center gap-2">
                          <div class="fw-bold">Preview</div>
                          <div class="small">
                            <strong>Net (Income − Expense):</strong>
                            <span :class="autoZero.preview.net_income_minus_expense > 0 ? 'text-success' : (autoZero.preview.net_income_minus_expense < 0 ? 'text-danger' : '')">
                              {{ displayNumber(autoZero.preview.net_income_minus_expense) }}
                              <span v-if="autoZero.preview.net_income_minus_expense > 0">(Profit)</span>
                              <span v-else-if="autoZero.preview.net_income_minus_expense < 0">(Loss)</span>
                              <span v-else>(Zero)</span>
                            </span>
                          <span v-if="autoZero.preview.gross_surplus != null" class="ms-2">
                            <strong>Gross surplus:</strong> {{ displayNumber(autoZero.preview.gross_surplus) }}
                          </span>
                          </div>
                        </div>

                        <div
                          v-if="autoZero.preview.auto_balance && autoZero.preview.auto_balance.used"
                          class="alert alert-info py-2 small mt-2 mb-0"
                        >
                          Imbalance of
                          <strong>{{ displayNumber(autoZero.preview.auto_balance.difference) }}</strong>
                          was balanced to
                          <strong>{{ autoZero.preview.auto_balance.ledger_difference_name }}</strong>
                          (ID: <strong>{{ autoZero.preview.auto_balance.ledger_difference_coa_subhead_id }}</strong>).
                        </div>
                        <div
                          v-else
                          class="small text-muted mt-2"
                        >
                          No imbalance detected.
                        </div>

                        <div v-if="autoZero.preview.unbalanced" class="alert alert-danger py-2 small mt-2 mb-0">
                          Preview totals are unbalanced. Please review before posting.
                        </div>

                        <div class="table-responsive mt-2">
                          <table class="table table-bordered table-sm">
                            <thead>
                              <tr>
                                <th>COA</th>
                                <th class="text-end">Previous balance</th>
                                <th class="text-end">Desired balance</th>
                                <th class="text-end">Delta</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(line, idx) in autoZero.preview.lines" :key="idx"
                                :class="line.auto_balanced_to_ledger_difference ? 'table-info' : (line.is_contra ? 'table-warning' : '')">
                                <td>{{ line.coa_name || "—" }}</td>
                                <td class="text-end">{{ displayNumber(line.previous_balance) }}</td>
                                <td class="text-end">{{ displayNumber(line.desired_balance) }}</td>
                                <td class="text-end">{{ displayNumber(line.delta) }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div class="row mt-2 small">
                          <div class="col-12 col-md-4">
                            <strong>Total debit:</strong> {{ displayNumber(autoZero.preview.total_debit) }}
                          </div>
                          <div class="col-12 col-md-4">
                            <strong>Total credit:</strong> {{ displayNumber(autoZero.preview.total_credit) }}
                          </div>
                          <div class="col-12 col-md-4">
                            <strong>Count:</strong> {{ autoZero.preview.count }}
                          </div>
                        </div>
                      </div>

                      <div v-if="autoZero.successMessage" class="alert alert-success mt-3 mb-0">
                        {{ autoZero.successMessage }}
                      </div>
                      <div v-if="autoZero.posted && autoZero.posted.auto_balance && autoZero.posted.auto_balance.used" class="alert alert-info py-2 small mt-2 mb-0">
                        Imbalance of
                        <strong>{{ displayNumber(autoZero.posted.auto_balance.difference) }}</strong>
                        was balanced to
                        <strong>{{ autoZero.posted.auto_balance.ledger_difference_name }}</strong>
                        (ID: <strong>{{ autoZero.posted.auto_balance.ledger_difference_coa_subhead_id }}</strong>).
                      </div>
                      <div v-if="autoZero.openingStatementBanner" class="alert alert-success py-2 small mt-2 mb-0">
                        {{ autoZero.openingStatementBanner }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Reversal (Undo Closure / Opening Statement) -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card card-shape home-box">
                  <div class="card-header d-flex flex-row align-items-center justify-content-between">
                    <h6 class="m-0 fw-bold text-green">Reversal (Undo Closure / Opening Statement)</h6>
                  </div>
                  <div class="card-body">
                    <div v-if="reversal.error" class="alert alert-danger py-2 small">{{ reversal.error }}</div>

                    <div class="row g-3">
                      <div class="col-12 col-md-4">
                        <label class="akkurate-dark">Recorded Date (FY end date)</label>
                        <b-form-input
                          v-model="form.recorded_date"
                          type="date"
                          class="mt-2 field-container fields"
                          :disabled="true"
                        />
                        <div class="small text-muted mt-1">
                          Uses the page recorded date (closure date).
                        </div>
                      </div>

                      <div class="col-12 col-md-4">
                        <label class="akkurate-dark">Opening Date (optional)</label>
                        <b-form-input
                          v-model="reversal.opening_date"
                          type="date"
                          class="mt-2 field-container fields"
                          :placeholder="defaultOpeningDate"
                        />
                        <div class="small text-muted mt-1">
                          Default is recorded date + 1 day.
                        </div>
                      </div>

                      <div class="col-12 col-md-4">
                        <label class="akkurate-dark">Closing reversal narration</label>
                        <b-form-input
                          v-model="reversal.narration"
                          type="text"
                          class="mt-2 field-container fields"
                          placeholder="CLOSING BALANCE"
                        />
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="col-12 col-md-4">
                        <b-form-checkbox v-model="reversal.reverseClosing">
                          Reverse Closing
                        </b-form-checkbox>
                      </div>
                      <div class="col-12 col-md-4">
                        <b-form-checkbox v-model="reversal.reverseOpening">
                          Reverse Opening Statement
                        </b-form-checkbox>
                      </div>
                      <div class="col-12 col-md-4">
                        <b-form-checkbox v-model="reversal.multiBranchEnabled">
                          Multi-branch reversal
                        </b-form-checkbox>
                      </div>
                    </div>

                    <div class="row mt-2" v-if="!reversal.multiBranchEnabled">
                      <div class="col-12 col-md-6">
                        <label class="akkurate-dark">Branch (optional)</label>
                        <b-form-group>
                          <multiselect
                            v-model="reversal.branch"
                            :options="branchOptions"
                            label="name"
                            track-by="id"
                            class="mt-2 field-container"
                            placeholder="Use my branch (default)"
                          />
                        </b-form-group>
                      </div>
                    </div>

                    <div class="row mt-2" v-else>
                      <div class="col-12">
                        <label class="akkurate-dark">Branches <star></star></label>
                        <b-form-group>
                          <multiselect
                            v-model="reversal.selectedBranches"
                            :options="branchOptions"
                            label="name"
                            track-by="id"
                            :multiple="true"
                            :close-on-select="false"
                            class="mt-2 field-container"
                            placeholder="Select branches"
                          />
                        </b-form-group>
                        <div class="small text-muted">
                          Select one or more branches to reverse.
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-wrap gap-2 mt-3">
                      <button
                        type="button"
                        class="btn akkurate-grey-btn border-0 btn-size"
                        :disabled="reversal.busy"
                        @click="previewReversal"
                      >
                        <b-spinner v-if="reversal.busy && reversal.lastDryRun" small class="me-1"></b-spinner>
                        Preview Reversal
                      </button>
                      <button
                        type="button"
                        class="btn akkurate-green-btn text-white btn-size"
                        :disabled="reversal.busy"
                        @click="confirmRunReversal"
                      >
                        <b-spinner v-if="reversal.busy && !reversal.lastDryRun" small class="me-1"></b-spinner>
                        Run Reversal
                      </button>
                    </div>

                    <div v-if="reversal.results && reversal.results.length" class="mt-3">
                      <div class="small text-muted mb-2">
                        Recorded date: <strong>{{ reversal.response_recorded_date || form.recorded_date }}</strong>
                        <span class="ms-2">Opening date: <strong>{{ reversal.response_opening_date || (reversal.opening_date || defaultOpeningDate) }}</strong></span>
                      </div>
                      <div class="table-responsive">
                        <table class="table table-bordered table-sm">
                          <thead>
                            <tr>
                              <th>Branch</th>
                              <th>Status</th>
                              <th>Closing rows reversed</th>
                              <th>Opening rows reversed</th>
                              <th>Message</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(r, idx) in reversal.results" :key="idx">
                              <td>{{ branchNameById(r.branch_id) }}</td>
                              <td>
                                <span class="badge" :class="String(r.status||'').toLowerCase() === 'ok' || String(r.status||'').toLowerCase() === 'success' ? 'bg-success' : 'bg-danger'">
                                  {{ r.status || '-' }}
                                </span>
                              </td>
                              <td>{{ r.closing_rows ?? '-' }}</td>
                              <td>{{ r.opening_rows ?? '-' }}</td>
                              <td>{{ r.message || '-' }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="!autoZero.enabled">
              <div class="d-flex flex-row align-items-center justify-content-between">
                <div class="err-accounts">
                  <errors v-if="form.errors.accounts">
                    {{ form.errors.accounts[0] }}
                  </errors>
                </div>
                <div class="col-12 col-md-12">
                  <div class="card card-shape home-box">
                    <div class="card-header d-flex flex-row align-items-center py-2">
                      <h6 class="m-0 fw-bold text-green">Accounts</h6>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12 col-md-3">
                          <label class="akkurate-dark" for="gl_ledger">GLedger <star></star></label>
                        </div>
                        <div class="col-12 col-md-2">
                          <label class="akkurate-dark" for="dr_amount">Current Balance <star></star></label>
                        </div>
                        <div class="col-12 col-md-2">
                          <label class="akkurate-dark" for="dr_amount">DR Balance (Desired)</label>
                        </div>
                        <div class="col-12 col-md-2">
                          <label class="akkurate-dark" for="cr_amount">CR Balance (Desired)</label>
                        </div>
                        
                        <div class="col-12 col-md-2">
                          <label class="akkurate-dark">Adjustment to post</label>
                        </div>

                      </div>
                      <div
                        class="row"
                        v-for="(field, index) in documents"
                        :key="index"
                        :class="isInvalidRow(field, index) ? 'border border-danger rounded p-1' : ''"
                      >
                        <div class="col-12 col-md-3">
                          <b-form-group>
                            <multiselect v-model="field.coa_subhead" name="coa_subhead" :options="coa_subhead_options"
                            @input="updateCoaBalance(field)"
                              class="mt-2 field-container" label="name" :custom-label="nameWithLang" required>
                            </multiselect>
                            <div v-if="isInvalidRow(field, index)" class="small text-danger mt-1">
                              {{ invalidRowMessage || `For ${field.coa_subhead?.name || "this COA"}, enter either Debit OR Credit (not both).` }}
                            </div>
                            <errors v-if="form.errors.coa_subhead">
                              {{ form.errors.coa_subhead[0] }}
                            </errors>
                          </b-form-group>
                        </div>

                        <div class="col-12 col-md-2">
                          <b-form-group label-for="dr_amount">
                            <b-form-input id="dr_amount" name="dr_amount" class="mt-2 field-container fields"
                              :value="displayNumber(currentBalanceAbs(field))"
                              type="text" inputmode="decimal" disabled
                              required></b-form-input>
                            <div class="small text-muted mt-1">
                              <span class="badge me-1" :class="currentBalanceSide(field) === 'CR' ? 'bg-danger' : 'bg-success'">
                                {{ currentBalanceSide(field) }}
                              </span>
                              <span v-if="currentBalanceAbs(field) === 0">No balance</span>
                            </div>
                            <errors v-if="form.errors.dr_amount">
                              {{ form.errors.dr_amount[0] }}
                            </errors>
                          </b-form-group>
                        </div>

                        <div class="col-12 col-md-2">
                          <b-form-group label-for="dr_amount">
                            <b-form-input id="dr_amount" name="dr_amount" class="mt-2 field-container fields"
                              type="text" inputmode="decimal" v-model="field.dr_balance_final"
                              @input="onAmountInput(field, 'dr_balance_final', $event)"
                              :disabled="drDisabled(field)"
                            ></b-form-input>
                            <div v-if="drDisabledReason(field)" class="small text-muted mt-1">
                              {{ drDisabledReason(field) }}
                            </div>
                            <div v-if="amountError(field?.dr_balance_final)" class="small text-danger mt-1">
                              {{ amountError(field?.dr_balance_final) }}
                            </div>
                            <errors v-if="form.errors.dr_amount">
                              {{ form.errors.dr_amount[0] }}
                            </errors>
                          </b-form-group>
                        </div>

                        <div class="col-12 col-md-2">
                          <b-form-group>
                            <b-form-input id="cr_amount" v-model="field.cr_balance_final" name="cr_amount"
                              class="mt-2 field-container fields" type="text" inputmode="decimal"
                              @input="onAmountInput(field, 'cr_balance_final', $event)"
                              :disabled="crDisabled(field)"
                            ></b-form-input>
                            <div v-if="crDisabledReason(field)" class="small text-muted mt-1">
                              {{ crDisabledReason(field) }}
                            </div>
                            <div v-if="amountError(field?.cr_balance_final)" class="small text-danger mt-1">
                              {{ amountError(field?.cr_balance_final) }}
                            </div>
                            <errors v-if="form.errors.cr_amount">
                              {{ form.errors.cr_amount[0] }}
                            </errors>
                          </b-form-group>
                        </div>
                        
                        <div class="col-12 col-md-2">
                          <b-form-group>
                            <b-form-input
                              id="coa_description"
                              name="coa_difference"
                              :value="displayNumber(adjustmentAbs(field))"
                              class="mt-2 field-container fields"
                              type="text" inputmode="decimal"
                              disabled
                            ></b-form-input>
                            <div class="small text-muted mt-1">
                              <span
                                class="badge me-1"
                                :class="adjustmentSide(field) === 'CREDIT' ? 'bg-danger' : (adjustmentSide(field) === 'DEBIT' ? 'bg-success' : 'bg-secondary')"
                              >
                                {{ adjustmentSide(field) }}
                              </span>
                              <span v-if="adjustmentSide(field) === 'NONE'">No posting required</span>
                            </div>
                            <errors v-if="form.errors.difference">
                              {{ form.errors.difference[0] }}
                            </errors>
                          </b-form-group>
                        </div>
                        <div class="col mt-auto">
                          <a
                            title="Zero this COA"
                            class="btn btn-sm akkurate-gray-btn border-0 me-1"
                            @click="zeroThisCoa(field)"
                          >
                            <span class="akkurate-small">Zero</span>
                          </a>
                          <a title="Delete" class="btn btn-sm akkurate-danger-btn text-white"
                            @click="removeField(index)">
                            <span class="akkurate-small"><font-awesome-icon :icon="['fas', 'trash']" /></span>
                          </a>
                        </div>
                      </div>
                      <!-- Displaying Total Debit and Total Credit (from adjustments) -->
                      <div class="row mt-4 justify-content-end ">
                        <div class="col-12 col-md-2">
                          <b-form-group>
                            <label>Total Debit</label>
                            <b-form-input class="field-container fields" type="text" :value="displayNumber(totalDebit)"
                              disabled></b-form-input>
                          </b-form-group>
                        </div>

                        <div class="col-12 col-md-2">
                          <b-form-group>
                            <label>Total Credit</label>
                            <b-form-input class="field-container fields" type="text" :value="displayNumber(totalCredit)"
                              disabled></b-form-input>
                          </b-form-group>
                        </div>
                        <div class="col-12 col-md-2">
                          <b-form-group>
                            <label>Total Difference</label>
                            <b-form-input class="field-container fields" type="text"
                              :value="displayNumber(totalDifference)" disabled></b-form-input>
                          </b-form-group>
                        </div>
                        <div class="col-12 col-md-1 mt-auto">
                          <a title="Delete" class="btn btn-sm akkurate-green-btn text-white"
                             @click="addAccount">
                            <span class="akkurate-small"><font-awesome-icon :icon="['fas', 'plus']" /></span>
                          </a>
                          <!-- <button type="button" @click="addAccount" class="btn akkurate-green-btn text-white btn-size">
                            <font-awesome-icon class="me-2" :icon="['fas', 'plus']" />
                          </button> -->
                        </div>
                      </div>
                      <p class="akkurate-danger small">{{ acc_error }}</p>
                      <!-- <div class="row mt-3">
                        <div class="col-md-12">
                          <button type="button" @click="addAccount" class="btn akkurate-green-btn text-white btn-size">
                            <font-awesome-icon class="me-2" :icon="['fas', 'plus']" /> Add
                          </button>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </form>

        <b-modal
          id="confirm-auto-zero"
          title="Confirm posting"
          @ok="applyAutoZero"
          :ok-disabled="isPostingFYT || autoZero.confirmText !== 'ZERO'"
          cancel-title="Cancel"
        >
          <div v-if="postingMessage" class="alert alert-warning py-2 small mb-2">
            <b-spinner small class="me-2"></b-spinner>
            {{ postingMessage }}
          </div>
          <div class="small text-danger mb-2">
            This will create accounting entries and cannot be undone without reversal.
          </div>
          <div class="small mb-2">
            Type <strong>ZERO</strong> to confirm.
          </div>
          <b-form-input v-model="autoZero.confirmText" class="field-container fields" placeholder="Type ZERO" />
          <div v-if="autoZero.confirmText && autoZero.confirmText !== 'ZERO'" class="small text-muted mt-2">
            Confirmation text must match exactly: ZERO
          </div>

          <template #modal-footer="{ ok, cancel }">
            <button
              type="button"
              class="btn btn-size akkurate-gray-btn modal-btn-width text-white me-2"
              :disabled="isPostingFYT"
              @click="cancel()"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-size akkurate-green-btn modal-btn-width text-white"
              :disabled="isPostingFYT || autoZero.confirmText !== 'ZERO'"
              @click="ok()"
            >
              <b-spinner v-if="isPostingFYT" small class="me-2"></b-spinner>
              Confirm
            </button>
          </template>
        </b-modal>
      </div>
      <footer></footer>
    </div>
  </div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import Footer from "@/views/main/components/Footer.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import JournalForm from '../forms/JournalForm.vue'
import AddAccount from '../forms/modal/AddAccount.vue'
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import { hasPermission } from '@/helper';
import { toCents, fromCents } from "@/utils/moneyCents";

export default {
  name: "JournalCreate",
  // watch: {
  //     fields: {
  //         deep: true,
  //         handler() {
  //             this.form.amount_requested = this.fields.reduce(
  //                 (total, field) => total + (field.difference || 0),
  //                 0
  //             )
  //         }
  //     }
  // },
  mounted() {
    this.loadPageOptions();
    this.checkPemission();
    this.loadActiveFinancialYear();
    this.loadBranches();
  },
  watch: {
    "autoZero.enabled"(next) {
      if (next) {
        // Auto Zero is always a Closing action.
        this.form.journal_type = { value: "close", text: "Closing" };
        this.enforceAutoZeroDates();
      }
    },
    "form.journal_type"(next) {
      // Keep balances refreshed (existing handler is @input), and enforce dates when auto-zero is on.
      if (this.autoZero.enabled) {
        // Keep it forced to closing.
        if (this.form?.journal_type?.value !== "close") {
          this.form.journal_type = { value: "close", text: "Closing" };
        }
        this.enforceAutoZeroDates();
      }
    },
    activeFY(next) {
      if (next && this.autoZero.enabled) this.enforceAutoZeroDates();
    },
    "form.recorded_date"(next) {
      if (this.autoZero.enabled) return;
      this.refreshManualBalances();
    },
    "form.prev_date"(next) {
      if (this.autoZero.enabled) return;
      this.refreshManualBalances();
    },
  },
  components: {
    SidebarView,
    Footer,
    TopbarView,
    JournalForm,
    AddAccount,
    Multiselect,
  },
  data() {
    return {
        ...this.initialState(),
        isLoading: false,
      coa_subhead_options: [],
      branch_options: [],
      branchOptions: [],
      coaOptionsByBranch: {},
      coaOptionsBusyByBranch: {},
      activeFY: null,
      invalidDrCrRowCoaSubheadId: null,
      invalidRowIndex: null,
      invalidRowMessage: "",
      add_or_edit: 'add',
      save: "Post",
      isSaving: false,
      acc_error: "",
      coa_desc_state: true,
        edit_date_pemission: true,
      autoZero: {
        enabled: false,
        generateOpeningStatement: true,
        multiBranchEnabled: false,
        selectedBranches: [],
        branchRows: {},
        multiBranchResults: [],
        copySourceBranch: null,
        multiBranchForbidden: false,
        statutoryReserve: null,
        operatingReserve: null,
        lossCarryforward: null,
        previewBusy: false,
        applyBusy: false,
        error: "",
        preview: null,
        posted: null,
        confirmText: "",
        successMessage: "",
        openingStatementBanner: "",
      },
      reversal: {
        opening_date: "",
        reverseClosing: true,
        reverseOpening: true,
        narration: "CLOSING BALANCE",
        multiBranchEnabled: false,
        selectedBranches: [],
        branch: null,
        busy: false,
        lastDryRun: true,
        error: "",
        results: [],
        response_recorded_date: "",
        response_opening_date: "",
      },
      isPostingFYT: false,
      postingMessage: "",
      journal_type_options: [
        { value: 'open', text: 'Opening' },
        { value: 'close', text: 'Closing' },
      ],
    };
  },
  computed: {
    debitTotalCents() {
      // Total DEBIT adjustments (difference > 0)
      return (this.documents || []).reduce((sum, field) => {
        const diff = this.differenceSigned(field);
        if (!Number.isFinite(diff) || diff <= 0) return sum;
        return sum + toCents(diff);
      }, 0);
    },
    creditTotalCents() {
      // Total CREDIT adjustments (difference < 0)
      return (this.documents || []).reduce((sum, field) => {
        const diff = this.differenceSigned(field);
        if (!Number.isFinite(diff) || diff >= 0) return sum;
        return sum + toCents(Math.abs(diff));
      }, 0);
    },
    /** DR vs CR imbalance (footer “Total Difference”). */
    journalImbalanceCents() {
      return this.debitTotalCents - this.creditTotalCents;
    },
    totalDebit() {
      return Number((this.debitTotalCents / 100).toFixed(2));
    },
    totalCredit() {
      return Number((this.creditTotalCents / 100).toFixed(2));
    },
    totalDifference() {
      return Number((this.journalImbalanceCents / 100).toFixed(2));
    },
    /** Sum of per-line variance from COA balance (for amount_requested). */
    lineDifferenceTotalCents() {
      return (this.documents || []).reduce((sum, field) => {
        const diff = this.differenceSigned(field);
        if (!Number.isFinite(diff)) return sum;
        return sum + toCents(Math.abs(diff));
      }, 0);
    },
    autoZeroCanApply() {
      return !!this.autoZero.preview && !this.autoZero.preview.unbalanced;
    },
    multiBranchAllValid() {
      if (!this.autoZero.multiBranchEnabled) return true;
      const branches = Array.isArray(this.autoZero.selectedBranches)
        ? this.autoZero.selectedBranches
        : [];
      if (branches.length === 0) return false;
      return branches.every((b) => this.branchValidation(b.id).ok);
    },
    autoZeroDateLocked() {
      if (!this.autoZero.enabled) return false;
      // Auto Zero is always closing; lock to ACTIVE FY end_date.
      return !!this.activeFY;
    },
    showLedgerDifferenceWarning() {
      // Warn only for manual mode: user is about to post potentially unbalanced lines.
      if (this.autoZero.enabled) return false;
      const selected = this.form?.ledger_difference_coa_subhead?.id;
      return !selected;
    },
    ledgerDifferenceBlockingError() {
      return this.form?.errors?.ledger_difference_coa_subhead_id || "";
    },
    defaultOpeningDate() {
      return this.addDaysIso(this.form?.recorded_date, 1);
    },
  },
  methods: {
    onAutoZeroMultiBranchToggle() {
      this.autoZero.error = "";
      this.autoZero.multiBranchResults = [];
      this.autoZero.copySourceBranch = null;
      if (!this.autoZero.multiBranchEnabled) return;
      this.onAutoZeroBranchesChanged();
    },
    async onAutoZeroBranchesChanged() {
      this.autoZero.error = "";
      this.autoZero.multiBranchResults = [];
      this.syncMultiBranchRows();
      const branches = Array.isArray(this.autoZero.selectedBranches) ? this.autoZero.selectedBranches : [];
      await Promise.all(branches.map((b) => this.ensureCoaOptionsForBranch(b.id)));
      if (!this.autoZero.copySourceBranch && branches.length) {
        this.autoZero.copySourceBranch = branches[0];
      }
    },
    async ensureCoaOptionsForBranch(branchId) {
      const id = Number(branchId);
      if (!id) return;
      if (Array.isArray(this.coaOptionsByBranch?.[id]) && this.coaOptionsByBranch[id].length) return;
      if (this.coaOptionsBusyByBranch?.[id]) return;
      this.$set(this.coaOptionsBusyByBranch, id, true);
      try {
        // Used elsewhere in the app for COA subhead dropdowns; supports branch filtering.
        const res = await ApiService.post("/finance/chart-of-accounts/subhead/dropdown", { branch_id: id });
        const list = res?.data?.coa_subheads || res?.data?.data?.coa_subheads || [];
        this.$set(this.coaOptionsByBranch, id, Array.isArray(list) ? list : []);
      } catch (e) {
        this.$set(this.coaOptionsByBranch, id, []);
      } finally {
        this.$set(this.coaOptionsBusyByBranch, id, false);
      }
    },
    branchLedgerDiffMissing(branchId) {
      const row = this.autoZero.branchRows?.[branchId] || {};
      return !row?.ledgerDiff?.id;
    },
    clearAutoZeroBranchRow(branchId) {
      const id = String(branchId);
      if (!this.autoZero.branchRows?.[id]) return;
      this.$set(this.autoZero.branchRows, id, { statutory: null, operating: null, loss: null, ledgerDiff: null });
    },
    findCoaInBranchOptions(branchId, coaId) {
      const id = Number(branchId);
      const list = this.coaSubheadsForBranch(id);
      const needle = Number(coaId);
      return (Array.isArray(list) ? list : []).find((x) => Number(x?.id) === needle) || null;
    },
    async copyAutoZeroConfigToAllBranches() {
      const source = this.autoZero.copySourceBranch;
      if (!source?.id) return;
      await this.ensureCoaOptionsForBranch(source.id);
      const srcRow = this.autoZero.branchRows?.[source.id] || {};
      const src = {
        statutoryId: srcRow?.statutory?.id,
        operatingId: srcRow?.operating?.id,
        lossId: srcRow?.loss?.id,
        ledgerDiffId: srcRow?.ledgerDiff?.id,
      };
      const branches = Array.isArray(this.autoZero.selectedBranches) ? this.autoZero.selectedBranches : [];
      await Promise.all(branches.map((b) => this.ensureCoaOptionsForBranch(b.id)));
      branches.forEach((b) => {
        const row = this.autoZero.branchRows?.[b.id] || { statutory: null, operating: null, loss: null, ledgerDiff: null };
        if (src.statutoryId) row.statutory = this.findCoaInBranchOptions(b.id, src.statutoryId) || row.statutory;
        if (src.operatingId) row.operating = this.findCoaInBranchOptions(b.id, src.operatingId) || row.operating;
        if (src.lossId) row.loss = this.findCoaInBranchOptions(b.id, src.lossId) || null;
        if (src.ledgerDiffId) row.ledgerDiff = this.findCoaInBranchOptions(b.id, src.ledgerDiffId) || null;
        this.$set(this.autoZero.branchRows, b.id, row);
      });
    },
    addDaysIso(iso, days) {
      if (!iso) return "";
      const raw = String(iso).trim();
      const delta = Number(days || 0);
      if (!raw) return "";

      // Prefer stable YYYY-MM-DD parsing and UTC arithmetic to avoid timezone skew.
      const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (m) {
        const year = Number(m[1]);
        const month = Number(m[2]);
        const day = Number(m[3]);
        const d = new Date(Date.UTC(year, month - 1, day));
        if (Number.isNaN(d.getTime())) return "";
        d.setUTCDate(d.getUTCDate() + delta);
        return d.toISOString().slice(0, 10);
      }

      // Fallback: parse whatever string we got, but still use UTC day math.
      const d = new Date(raw);
      if (Number.isNaN(d.getTime())) return "";
      d.setUTCDate(d.getUTCDate() + delta);
      return d.toISOString().slice(0, 10);
    },
    validateReversalBranches() {
      if (!this.reversal.multiBranchEnabled) return true;
      const selected = Array.isArray(this.reversal.selectedBranches) ? this.reversal.selectedBranches : [];
      if (selected.length === 0) {
        this.reversal.error = "Please select at least one branch for multi-branch reversal.";
        return false;
      }
      return true;
    },
    buildReversalPayload(dry_run) {
      const recorded_date = this.form?.recorded_date;
      const opening_date = this.reversal.opening_date || this.defaultOpeningDate || null;
      const narration = (this.reversal.narration || "").trim() || "CLOSING BALANCE";

      const base = {
        recorded_date,
        opening_date,
        reverse_closing: !!this.reversal.reverseClosing,
        reverse_opening_statement: !!this.reversal.reverseOpening,
        narration,
        dry_run: !!dry_run,
      };

      if (this.reversal.multiBranchEnabled) {
        const branches = Array.isArray(this.reversal?.selectedBranches)
          ? this.reversal.selectedBranches
          : [];
        return {
          ...base,
          branches: branches.map((b) => ({ branch_id: b.id })),
        };
      }

      const branch_id = this.reversal.branch?.id || null;
      return branch_id ? { ...base, branch_id } : base;
    },
    async previewReversal() {
      this.reversal.busy = true;
      this.reversal.lastDryRun = true;
      this.reversal.error = "";
      this.reversal.results = [];
      try {
        if (!this.validateReversalBranches()) return;
        const payload = this.buildReversalPayload(true);
        const res = await ApiService.post("/journals/financial-year-transaction/reverse", payload);
        const raw = res?.data?.data || res?.data || {};
        this.reversal.results = Array.isArray(raw?.results) ? raw.results : [];
        this.reversal.response_recorded_date = raw?.recorded_date || "";
        this.reversal.response_opening_date = raw?.opening_date || "";
      } catch (e) {
        const msg = e?.response?.data?.message || "Failed to preview reversal.";
        if (e?.response?.status === 403 && String(msg).toLowerCase().includes("cross-branch")) {
          this.reversal.error = "You need Finance Admin permission to reverse across branches.";
        } else {
          this.reversal.error = msg;
        }
      } finally {
        this.reversal.busy = false;
      }
    },
    confirmRunReversal() {
      this.reversal.error = "";
      if (!this.validateReversalBranches()) return;
      const branchesCount = this.reversal.multiBranchEnabled
        ? (Array.isArray(this.reversal?.selectedBranches) ? this.reversal.selectedBranches.length : 0)
        : 1;
      const opening_date = this.reversal.opening_date || this.defaultOpeningDate || "-";
      const recorded_date = this.form?.recorded_date || "-";
      const summary = `Branches: ${branchesCount}\nReverse closing: ${this.reversal.reverseClosing ? "YES" : "NO"}\nReverse opening: ${this.reversal.reverseOpening ? "YES" : "NO"}\nRecorded date: ${recorded_date}\nOpening date: ${opening_date}`;

      swal.fire({
        title: "Confirm reversal",
        text: summary,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Run",
        cancelButtonText: "Cancel",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-size akkurate-green-btn modal-btn-width text-white me-2",
          cancelButton: "btn btn-size akkurate-gray-btn modal-btn-width text-white",
        },
      }).then((r) => {
        if (r.isConfirmed) this.runReversal();
      });
    },
    async runReversal() {
      this.reversal.busy = true;
      this.reversal.lastDryRun = false;
      this.reversal.error = "";
      this.reversal.results = [];
      try {
        if (!this.validateReversalBranches()) return;
        const payload = this.buildReversalPayload(false);
        const res = await ApiService.post("/journals/financial-year-transaction/reverse", payload);
        const raw = res?.data?.data || res?.data || {};
        this.reversal.results = Array.isArray(raw?.results) ? raw.results : [];
        this.reversal.response_recorded_date = raw?.recorded_date || "";
        this.reversal.response_opening_date = raw?.opening_date || "";
        toast.fire({
          icon: "success",
          title: res?.data?.message || "Reversal completed",
        });
      } catch (e) {
        const msg = e?.response?.data?.message || "Failed to run reversal.";
        if (e?.response?.status === 403 && String(msg).toLowerCase().includes("cross-branch")) {
          this.reversal.error = "You need Finance Admin permission to reverse across branches.";
        } else {
          this.reversal.error = msg;
        }
      } finally {
        this.reversal.busy = false;
      }
    },
    async loadBranches() {
      try {
        const res = await ApiService.get("/accounts/create/dropdown");
        const branches = res?.data?.branches || [];
        this.branchOptions = Array.isArray(branches) ? branches : [];
      } catch (e) {
        this.branchOptions = [];
      }
    },
    branchNameById(branchId) {
      const id = Number(branchId);
      const b = (this.branchOptions || []).find((x) => Number(x?.id) === id);
      return b?.name || "-";
    },
    coaSubheadsForBranch(branchId) {
      const id = Number(branchId);
      const cached = this.coaOptionsByBranch?.[id];
      if (Array.isArray(cached) && cached.length) return cached;
      // Fallback to whatever was loaded for user branch; may not include other branches.
      return Array.isArray(this.coa_subhead_options) ? this.coa_subhead_options : [];
    },
    syncMultiBranchRows() {
      const selected = Array.isArray(this.autoZero.selectedBranches)
        ? this.autoZero.selectedBranches
        : [];
      const next = { ...(this.autoZero.branchRows || {}) };
      selected.forEach((b) => {
        if (!next[b.id]) {
          next[b.id] = { statutory: null, operating: null, loss: null, ledgerDiff: null };
        }
      });
      // drop rows for unselected branches
      Object.keys(next).forEach((k) => {
        if (!selected.some((b) => String(b.id) === String(k))) delete next[k];
      });
      this.autoZero.branchRows = next;
    },
    branchValidation(branchId) {
      const row = this.autoZero.branchRows?.[branchId] || {};
      const statutoryId = row?.statutory?.id;
      const operatingId = row?.operating?.id;
      const lossId = row?.loss?.id;
      if (!statutoryId) return { ok: false, message: "Statutory is required" };
      if (!operatingId) return { ok: false, message: "Operating is required" };
      if (statutoryId === operatingId) return { ok: false, message: "Statutory must differ from Operating" };
      if (lossId && (lossId === statutoryId || lossId === operatingId)) {
        return { ok: false, message: "Loss must differ from Statutory/Operating" };
      }
      return { ok: true, message: "" };
    },
    async refreshManualBalances() {
      // Refresh current balances for all selected GLs (manual FYT mode).
      if (this.autoZero.enabled) return;
      const rows = Array.isArray(this.documents) ? this.documents : [];
      for (const r of rows) {
        if (r?.coa_subhead?.id) {
          // fire sequentially to avoid request bursts; good enough for small row counts
          // eslint-disable-next-line no-await-in-loop
          await this.fetchBalanceForRow(r);
        }
      }
    },
    async fetchBalanceForRow(row) {
      const coaId = row?.coa_subhead?.id;
      if (!coaId) return;
      if (!this.form?.recorded_date) return;
      const prev_date = this.form?.prev_date || this.computePrevDate();
      if (!prev_date) return;

      try {
        const response = await ApiService.post(
          "/journals/financial-year-transaction/coa-balances",
          {
            coa_id: coaId,
            date: this.form.recorded_date,
            prev_date: prev_date,
          }
        );
        const balances = response?.data?.balances || {};
        const jt = this.form?.journal_type?.value || "open";
        const raw =
          jt === "close"
            ? balances.closing_balance
            : balances.opening_balance;
        const n = this.parseAmount(raw);
        row.current_balance_signed = Number.isFinite(n) ? n : 0;
      } catch (e) {
        row.current_balance_signed = 0;
      }
    },
    currentBalanceAbs(row) {
      const n = this.parseAmount(row?.current_balance_signed);
      if (!Number.isFinite(n)) return 0;
      return Math.abs(n);
    },
    currentBalanceSide(row) {
      const n = this.parseAmount(row?.current_balance_signed);
      if (!Number.isFinite(n) || n === 0) return "DR";
      return n > 0 ? "DR" : "CR";
    },
    adjustmentSide(field) {
      const desired = this.desiredSignedBalance(field);
      if (desired == null) return "NONE";
      const diff = this.differenceSigned(field);
      if (!Number.isFinite(diff) || diff === 0) return "NONE";
      return diff > 0 ? "DEBIT" : "CREDIT";
    },
    adjustmentAbs(field) {
      const desired = this.desiredSignedBalance(field);
      if (desired == null) return 0;
      const diff = this.differenceSigned(field);
      if (!Number.isFinite(diff)) return 0;
      return Math.abs(diff);
    },
    parseAmount(v) {
      if (v === null || v === undefined) return 0;
      const s = String(v).replace(/,/g, "").trim();
      if (s === "") return 0;
      const n = Number(s);
      return Number.isFinite(n) ? n : NaN;
    },
    hasPositiveAmount(value) {
      const n = this.parseAmount(value);
      return Number.isFinite(n) && n > 0;
    },
    hasNumericAmountEntered(value) {
      // "Not empty" rule: any non-empty, parseable number counts as entered (including 0).
      const raw = String(value ?? "").trim();
      if (raw === "") return false;
      const n = this.parseAmount(value);
      return Number.isFinite(n);
    },
    isZeroOrEmpty(value) {
      const n = this.parseAmount(value);
      return String(value ?? "").trim() === "" || (Number.isFinite(n) && n === 0);
    },
    amountError(value) {
      const raw = String(value ?? "").trim();
      if (raw === "") return "";
      const n = this.parseAmount(value);
      if (Number.isNaN(n)) return "Enter a valid number";
      return "";
    },
    sanitizeAmountInputString(v) {
      let s = String(v ?? "");
      // allow digits + a single dot
      s = s.replace(/,/g, "");
      s = s.replace(/[^\d.]/g, "");
      const parts = s.split(".");
      if (parts.length <= 1) return s;
      return `${parts[0]}.${parts.slice(1).join("")}`;
    },
    onAmountInput(field, prop, value) {
      const next = this.sanitizeAmountInputString(value);
      field[prop] = next;
    },
    prevSignedBalance(field) {
      // Previous balance is fetched via /coa-balances and stored on coa_subhead.amount.
      // We treat it as signed: DR positive, CR negative (as per backend/UI convention).
      const n = this.parseAmount(field?.coa_subhead?.amount);
      return Number.isFinite(n) ? n : 0;
    },
    desiredSignedBalance(field) {
      // Desired final balance:
      // - DR input => +amount
      // - CR input => -amount
      // - explicit zero action => 0
      if (field?.zeroDesired === true) return 0;
      if (this.hasNumericAmountEntered(field?.dr_balance_final)) {
        return this.parseAmount(field?.dr_balance_final);
      }
      if (this.hasNumericAmountEntered(field?.cr_balance_final)) {
        return -Math.abs(this.parseAmount(field?.cr_balance_final));
      }
      return null; // unchanged / blank
    },
    differenceSigned(field) {
      const desired = this.desiredSignedBalance(field);
      if (desired == null) return NaN;
      const prev = this.prevSignedBalance(field);
      return Number((desired - prev).toFixed(2));
    },
    adjustmentLabel(field) {
      const desired = this.desiredSignedBalance(field);
      if (desired == null) return "—";
      const diff = this.differenceSigned(field);
      if (!Number.isFinite(diff)) return "—";
      if (diff > 0) return `DEBIT ${this.displayNumber(diff)}`;
      if (diff < 0) return `CREDIT ${this.displayNumber(Math.abs(diff))}`;
      return "No posting required";
    },
    zeroThisCoa(field) {
      field.zeroDesired = true;
      field.dr_balance_final = "";
      field.cr_balance_final = "";
    },
    isInvalidRow(field, index) {
      if (this.invalidRowIndex != null) return Number(index) === Number(this.invalidRowIndex);
      const id = field?.coa_subhead?.id;
      if (!id || !this.invalidDrCrRowCoaSubheadId) return false;
      return Number(id) === Number(this.invalidDrCrRowCoaSubheadId);
    },
    drDisabledReason(field) {
      return this.hasNumericAmountEntered(field?.cr_balance_final)
        ? "Disabled because Credit is entered"
        : "";
    },
    crDisabledReason(field) {
      return this.hasNumericAmountEntered(field?.dr_balance_final)
        ? "Disabled because Debit is entered"
        : "";
    },
    async loadActiveFinancialYear() {
      try {
        const res = await ApiService.get("/setup/financial-years/all");
        const years = res?.data?.data || [];
        const list = Array.isArray(years) ? years : [];
        const active =
          list.find((y) => String(y?.status || "").toUpperCase() === "ACTIVE") ||
          list.find((y) => String(y?.status || "").toUpperCase() === "ACTIVE FY") ||
          null;
        this.activeFY = active;
      } catch (e) {
        this.activeFY = null;
      }
    },
    enforceAutoZeroDates() {
      if (!this.autoZero.enabled) return;
      if (!this.activeFY) return;

      // Backend rule (must match UI):
      // - close: recorded_date must equal ACTIVE FY end_date
      this.form.recorded_date = this.activeFY.end_date;
    },
    isLedgerDifferenceMessage(msg) {
      const s = String(msg || "").toLowerCase();
      return s.includes("ledger difference") || s.includes("ledger-difference");
    },
    setLedgerDifferenceBlockingError() {
      if (!this.form.errors || typeof this.form.errors !== "object") {
        this.form.errors = {};
      }
      this.$set(
        this.form.errors,
        "ledger_difference_coa_subhead_id",
        "Ledger Difference GL is required. Create/select a COA subhead named ‘LEDGER DIFFERENCE’ or choose one in the dropdown."
      );
    },
      hasNonZeroAmount(value) {
        if (value === null || value === undefined) return false;
        if (String(value).trim() === "") return false;
        const n = Number(value);
        return Number.isFinite(n) && n !== 0;
      },
      // legacy hasNonEmptyAmount removed; use hasPositiveAmount for DR/CR mutual exclusion
      async updateCoaBalance(field) {
        if (!field?.coa_subhead?.id) return;
        field.zeroDesired = false;
        await this.fetchBalanceForRow(field);
      },

      // Refresh all balances when journal_type changes
      refreshAllBalances() {
        if (this.autoZero.enabled) return;
        (this.documents || []).forEach((doc) => {
          this.updateCoaBalance(doc);
        });
      },

      // getBalance removed in favor of fetchBalanceForRow + current_balance_signed

      calculateDifference(field) {
        const raw =
          field.dr_amount !== "" && field.dr_amount != null
            ? field.dr_amount
            : field.cr_amount !== "" && field.cr_amount != null
              ? field.cr_amount
              : 0;
        const desiredCents = toCents(raw);
        const currentCents = toCents(field.coa_subhead?.amount);
        const diffCents = Math.abs(desiredCents - currentCents);
        field.differenceCents = diffCents;
        field.difference = Number(fromCents(diffCents));
        return field.difference;
    },
    checkPemission() {
      if (hasPermission('journal_management_edit_date')) {
        this.edit_date_pemission =  false
      } else {
        this.edit_date_pemission =  true
      }
    },
    loadPageOptions() {
      this.$Progress.start();
      this.isLoading = true;
      
      ApiService.get("/journals/dropdown")
        .then((response) => {
          this.coa_subhead_options = response.data.coa_subheads;
          // this.branch_options = response.data.branches;
          this.form.branch = response.data.user_branch;
          // console.log(this.form.branch)
          // console.log(response.data.branches?.[0].name);
          // console.log(response.data);
          this.isLoading = false;
          this.$Progress.finish();
        })
        .catch((error) => {
          this.isLoading = false;
          this.$Progress.fail();
        });
    },

    computePrevDate() {
      if (!this.form.recorded_date) return "";
      const currentDate = new Date(this.form.recorded_date);
      const prevDate = new Date(currentDate - 1);
      const day = prevDate.getDate();
      const month = prevDate.getMonth() + 1;
      const year = prevDate.getFullYear();
      return `${year}-${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day}`;
    },
    normalizeAutoZeroPreviewResponse(res) {
      const raw = res?.data?.data || res?.data || {};

      // Net (Income − Expense) must come from backend-provided net fields, not debit/credit totals.
      const results = Array.isArray(raw?.results) ? raw.results : [];
      const singleResult = raw?.result || null;

      let net_income_minus_expense = null;
      if (results.length > 0) {
        const nums = results
          .map((r) => r?.net_income_minus_expense)
          .filter((v) => v !== null && v !== undefined && v !== "");
        const parsed = nums.map((v) => Number(v)).filter((n) => Number.isFinite(n));
        if (parsed.length > 0) {
          net_income_minus_expense = parsed.reduce((a, b) => a + b, 0);
        }
      } else if (singleResult && singleResult.net_income_minus_expense !== undefined) {
        const n = Number(singleResult.net_income_minus_expense);
        net_income_minus_expense = Number.isFinite(n) ? n : null;
      } else if (raw?.net_income_minus_expense !== undefined) {
        // Backward compatible fallback for older shape.
        const n = Number(raw.net_income_minus_expense);
        net_income_minus_expense = Number.isFinite(n) ? n : null;
      }

      const grossSurplusRaw =
        raw?.income_statement_totals?.gross_surplus ??
        singleResult?.income_statement_totals?.gross_surplus ??
        null;
      const gross_surplus =
        grossSurplusRaw === null || grossSurplusRaw === undefined || grossSurplusRaw === ""
          ? null
          : (Number.isFinite(Number(grossSurplusRaw)) ? Number(grossSurplusRaw) : null);

      if (gross_surplus != null && net_income_minus_expense != null) {
        if (Math.abs(Number(gross_surplus) - Number(net_income_minus_expense)) > 0.005) {
          // eslint-disable-next-line no-console
          console.warn(
            "[FYT] gross_surplus mismatch",
            { gross_surplus, net_income_minus_expense }
          );
        }
      }
      const auto_balance = raw.auto_balance || null;
      const linesRaw = raw.lines || raw.preview_lines || raw.data || [];
      const lines = Array.isArray(linesRaw) ? linesRaw : [];
      const totals = raw.totals || {};

      const normLines = lines.map((l) => ({
        coa_name: l?.coa_name || l?.coa_subhead_name || l?.coa_subhead?.name || l?.name || "",
        previous_balance: l?.previous_balance ?? l?.prev_balance ?? 0,
        desired_balance: l?.desired_balance ?? l?.target_balance ?? 0,
        delta: l?.delta ?? l?.change ?? 0,
        is_contra: Boolean(l?.is_contra || l?.isContra || l?.contra),
        auto_balanced_to_ledger_difference: Boolean(
          l?.auto_balanced_to_ledger_difference ||
          l?.autoBalancedToLedgerDifference
        ),
      }));

      const total_debit = Number(totals.debit ?? totals.total_debit ?? 0);
      const total_credit = Number(totals.credit ?? totals.total_credit ?? 0);
      const count = Number(totals.count ?? totals.total_count ?? normLines.length);
      const unbalanced = Math.abs(total_debit - total_credit) > 0.005;

      return {
        net_income_minus_expense,
        gross_surplus,
        auto_balance,
        lines: normLines,
        total_debit,
        total_credit,
        count,
        unbalanced,
      };
    },
    buildAutoZeroPayload(dry_run) {
      this.autoZero.error = "";
      this.autoZero.successMessage = "";
      this.autoZero.openingStatementBanner = "";
      this.autoZero.multiBranchResults = [];
      this.autoZero.multiBranchForbidden = false;

      if (!this.activeFY) {
        this.autoZero.error = "No active financial year. Activate one before using Auto Zero.";
        return null;
      }
      // Force closing for auto-zero.
      this.form.journal_type = { value: "close", text: "Closing" };
      this.enforceAutoZeroDates();

      if (!this.form.journal_type?.value) {
        this.autoZero.error = "Posting Type is required (top section).";
        return null;
      }
      if (!this.form.recorded_date) {
        this.autoZero.error = "Date is required (top section).";
        return null;
      }
      if (this.activeFY?.end_date && this.form.recorded_date !== this.activeFY.end_date) {
        this.autoZero.error = `Recorded date must equal ACTIVE FY end date (${this.activeFY.end_date}).`;
        // Reset the locked date to expected end_date to reduce retries.
        this.form.recorded_date = this.activeFY.end_date;
        return null;
      }
      const prev_date = this.form.prev_date || this.computePrevDate();
      if (!prev_date) {
        this.autoZero.error = "Prev date could not be computed.";
        return null;
      }

      if (this.autoZero.multiBranchEnabled) {
        const branches = Array.isArray(this.autoZero.selectedBranches)
          ? this.autoZero.selectedBranches
          : [];
        if (branches.length === 0) {
          this.autoZero.error = "Please select at least one branch.";
          return null;
        }
        // Ensure internal rows map exists
        this.syncMultiBranchRows();
        const invalid = branches.find((b) => !this.branchValidation(b.id).ok);
        if (invalid) {
          this.autoZero.error = `Fix branch configuration for: ${invalid.name || invalid.id}`;
          return null;
        }

        return {
          journal_type: { value: "close", text: "Closing" },
          prev_date,
          recorded_date: this.form.recorded_date,
          narration:
            this.form.narration && String(this.form.narration).trim() !== ""
              ? this.form.narration
              : "BEGINNING YEAR OPENING BALANCE",
          auto_zero_income_expense: true,
          dry_run: !!dry_run,
          generate_opening_statement: !!this.autoZero.generateOpeningStatement,
          branches: branches.map((b) => {
            const r = this.autoZero.branchRows?.[b.id] || {};
            return {
              branch_id: b.id,
              statutory_reserve_coa_subhead_id: r?.statutory?.id,
              operating_reserve_coa_subhead_id: r?.operating?.id,
              loss_carryforward_coa_subhead_id: r?.loss?.id || null,
              ledger_difference_coa_subhead_id: r?.ledgerDiff?.id || null,
            };
          }),
        };
      }

      if (!this.autoZero.statutoryReserve?.id) {
        this.autoZero.error = "Statutory Reserve GL is required.";
        return null;
      }
      if (!this.autoZero.operatingReserve?.id) {
        this.autoZero.error = "Operating Reserve GL is required.";
        return null;
      }

      return {
        journal_type: { value: "close", text: "Closing" },
        prev_date,
        recorded_date: this.form.recorded_date,
        narration:
          this.form.narration && String(this.form.narration).trim() !== ""
            ? this.form.narration
            : "BEGINNING YEAR OPENING BALANCE",
        ledger_difference_coa_subhead_id: this.form?.ledger_difference_coa_subhead?.id || undefined,
        auto_zero_income_expense: true,
        statutory_reserve_coa_subhead_id: this.autoZero.statutoryReserve.id,
        operating_reserve_coa_subhead_id: this.autoZero.operatingReserve.id,
        loss_carryforward_coa_subhead_id: this.autoZero.lossCarryforward?.id || undefined,
        generate_opening_statement: !!this.autoZero.generateOpeningStatement,
        dry_run: !!dry_run,
      };
    },
    async previewAutoZero() {
      const payload = this.buildAutoZeroPayload(true);
      if (!payload) return;

      this.autoZero.previewBusy = true;
      this.autoZero.preview = null;
      try {
        const res = await ApiService.post("/journals/financial-year-transaction/store", payload);
        this.autoZero.preview = this.normalizeAutoZeroPreviewResponse(res);
        const raw = res?.data?.data || res?.data || {};
        this.autoZero.multiBranchResults = Array.isArray(raw?.results) ? raw.results : [];
      } catch (e) {
        const msg = e?.response?.data?.message || "";
        if (e?.response?.status === 403 && msg.toLowerCase().includes("multi-branch")) {
          this.autoZero.error = "You need Finance Admin permission to run closure across branches.";
          this.autoZero.multiBranchForbidden = true;
          return;
        }
        const expectedStart = e?.response?.data?.expected_start_date;
        const expectedEnd = e?.response?.data?.expected_end_date;
        if (expectedStart || expectedEnd) {
          // Reset locked dates to what backend expects.
          if (this.activeFY) this.enforceAutoZeroDates();
          this.autoZero.error = `Date must match ACTIVE FY (${this.activeFY?.start_date || expectedStart} → ${this.activeFY?.end_date || expectedEnd}).`;
          return;
        }
        if (this.isLedgerDifferenceMessage(msg)) {
          this.setLedgerDifferenceBlockingError();
          this.autoZero.error =
            "Ledger Difference GL is required. Create/select a COA subhead named ‘LEDGER DIFFERENCE’ or choose one in the dropdown.";
          return;
        }
        this.autoZero.error = msg || "Preview failed. Please check inputs and try again.";
      } finally {
        this.autoZero.previewBusy = false;
      }
    },
    openAutoZeroConfirm() {
      if (!this.autoZeroCanApply) return;
      this.autoZero.confirmText = "";
      this.$bvModal.show("confirm-auto-zero");
    },
    async applyAutoZero(bvModalEvent) {
      if (bvModalEvent) bvModalEvent.preventDefault();
      if (this.autoZero.confirmText !== "ZERO") return;
      if (this.isPostingFYT) return;

      const payload = this.buildAutoZeroPayload(false);
      if (!payload) return;

      this.autoZero.applyBusy = true;
      this.isPostingFYT = true;
      this.postingMessage = "Posting year-end closing… please wait. Do not click again.";
      try {
        const res = await ApiService.post("/journals/financial-year-transaction/store", payload);
        const posted = this.normalizeAutoZeroPreviewResponse(res);
        const raw = res?.data?.data || res?.data || {};
        const opening = raw?.opening_statement || null;
        this.autoZero.multiBranchResults = Array.isArray(raw?.results) ? raw.results : [];
        toast.fire({
          icon: "success",
          title: res?.data?.message || "Auto zero completed successfully",
        });
        this.autoZero.successMessage = "Auto zero completed successfully";
        // Preserve the imbalance treatment summary for the user after posting.
        this.autoZero.posted = posted;
        if (opening?.generated === true) {
          this.autoZero.openingStatementBanner = `Closing posted. Opening balances generated: ${opening?.posted_count} lines on ${opening?.opening_date}.`;
        } else {
          this.autoZero.openingStatementBanner = "Closing posted. Opening statement generation disabled.";
        }
        this.$bvModal.hide("confirm-auto-zero");
      } catch (e) {
        const msg = e?.response?.data?.message || "";
        const deadlock =
          String(msg).includes("SQLSTATE[40001]") ||
          String(msg).toLowerCase().includes("deadlock found");
        if (deadlock) {
          toast.fire({
            icon: "error",
            title: "Database busy (deadlock). Please wait a moment and try again.",
          });
          this.autoZero.error = msg || "Database deadlock.";
          return;
        }
        if (e?.response?.status === 403 && msg.toLowerCase().includes("multi-branch")) {
          this.autoZero.error = "You need Finance Admin permission to run closure across branches.";
          this.autoZero.multiBranchForbidden = true;
          return;
        }
        const expectedStart = e?.response?.data?.expected_start_date;
        const expectedEnd = e?.response?.data?.expected_end_date;
        if (expectedStart || expectedEnd) {
          if (this.activeFY) this.enforceAutoZeroDates();
          this.autoZero.error = `Date must match ACTIVE FY (${this.activeFY?.start_date || expectedStart} → ${this.activeFY?.end_date || expectedEnd}).`;
          return;
        }
        if (this.isLedgerDifferenceMessage(msg)) {
          this.setLedgerDifferenceBlockingError();
          this.autoZero.error =
            "Ledger Difference GL is required. Create/select a COA subhead named ‘LEDGER DIFFERENCE’ or choose one in the dropdown.";
          return;
        }
        this.autoZero.error = msg || "Posting failed. Nothing was applied.";
      } finally {
        this.autoZero.applyBusy = false;
        this.isPostingFYT = false;
        this.postingMessage = "";
      }
    },

    addAccount() {
      this.documents.push({
        dr_balance_final: "",
        cr_balance_final: "",
        differenceCents: 0,
        zeroDesired: false,
        current_balance_signed: 0,
        coa_subhead: { id: "", name: "", code: "", coahead: {}, amount: 0 },
      });
      this.acc_error = ""
      this.isSaving = false
    },
    removeField(index) {
      this.documents.splice(index, 1);

      this.acc_error = ""
      this.isSaving = false
    },
    submitJournal() {
      if (this.autoZero.enabled) {
        this.form.message = "Auto Zero mode is enabled. Use Preview / Apply instead of manual posting.";
        return;
      }
      this.invalidDrCrRowCoaSubheadId = null;
      this.invalidRowIndex = null;
      this.invalidRowMessage = "";

      // Per-row validation:
      // - Allow blank rows (both zero/empty and no explicit zeroDesired)
      // - Error only if both DR and CR are positive OR non-numeric
      for (let i = 0; i < (this.documents || []).length; i++) {
        const row = this.documents[i];
        const drPos = this.hasPositiveAmount(row?.dr_balance_final);
        const crPos = this.hasPositiveAmount(row?.cr_balance_final);
        const drEmpty = this.isZeroOrEmpty(row?.dr_balance_final);
        const crEmpty = this.isZeroOrEmpty(row?.cr_balance_final);

        // If user typed a non-numeric value, block.
        if (this.amountError(row?.dr_balance_final) || this.amountError(row?.cr_balance_final)) {
          this.invalidRowIndex = i;
          this.invalidRowMessage = "Enter a valid number.";
          this.form.message = this.invalidRowMessage;
          return;
        }

        // Allow fully blank rows (skip)
        if (drEmpty && crEmpty && row?.zeroDesired !== true) continue;

        if (drPos && crPos) {
          this.invalidRowIndex = i;
          this.invalidDrCrRowCoaSubheadId = row?.coa_subhead?.id || null;
          this.invalidRowMessage = `For ${row?.coa_subhead?.name || "this COA"}, enter either Debit OR Credit (not both).`;
          this.form.message = this.invalidRowMessage;
          return;
        }
      }

      // Clear ledger-difference blocking error before submit attempt
      if (this.form?.errors?.ledger_difference_coa_subhead_id) {
        this.$delete(this.form.errors, "ledger_difference_coa_subhead_id");
      }
      this.isSaving = true;
      this.$Progress.start();
      this.save = "Posting..."
      const EPS = 0.00001;
      // Payload (critical): send only changed rows with numeric `difference`.
      // Filter out unchanged (difference === 0) and blank (no desired set).
      this.form.vouch_journ_coa_accounts = (this.documents || [])
        .map((row) => {
          const desired = this.desiredSignedBalance(row);
          if (desired == null) return null;
          const diff = this.differenceSigned(row);
          if (!Number.isFinite(diff)) return null;
          if (Math.abs(diff) < EPS) return null;
          return {
            coa_subhead_id: row?.coa_subhead?.id,
            difference: diff,
            desired_balance: desired,
            previous_balance: this.prevSignedBalance(row),
          };
        })
        .filter(Boolean);

      // Client-side validation (before submit)
      for (let i = 0; i < this.form.vouch_journ_coa_accounts.length; i++) {
        const r = this.form.vouch_journ_coa_accounts[i];
        if (!r?.coa_subhead_id) {
          this.isSaving = false;
          this.$Progress.fail();
          this.save = "Post";
          this.invalidRowIndex = i;
          this.invalidRowMessage = "Select a COA account for this row.";
          this.form.message = this.invalidRowMessage;
          return;
        }
        if (!Number.isFinite(r?.difference)) {
          this.isSaving = false;
          this.$Progress.fail();
          this.save = "Post";
          this.invalidRowIndex = i;
          this.invalidRowMessage = "Enter a valid difference amount.";
          this.form.message = this.invalidRowMessage;
          return;
        }
      }
      this.form.ledger_difference_coa_subhead_id =
        this.form?.ledger_difference_coa_subhead?.id || null;

      // console.log("Form:", this.form);
      this.form.amount_requested = Number(
        (this.lineDifferenceTotalCents / 100).toFixed(2)
      );

      // console.log(this.form.recorded_date)
        const currentDate = new Date(this.form.recorded_date);
        const prevDate = new Date(currentDate - 1)

        const day = prevDate.getDate()
        const month = prevDate.getMonth() + 1
        const year = prevDate.getFullYear()
                  
        const prev_date = `${year}-${month<10? "0"+month:month}-${day<10? "0"+day:day}`
      this.form.prev_date = prev_date;

      ApiService.post("/journals/financial-year-transaction/store", this.form)
        .then((response) => {
          this.isSaving = false;
          this.$Progress.finish();
          this.save = "Post"
          toast.fire({
            icon: "success",
            title: response.data.message,
          });

          this.form = this.initialState().form;
          this.documents = [
            {
              dr_amount: "",
              cr_amount: "",
              differenceCents: 0,
              coa_subhead: { id: "", name: "", code: "", coahead: {} },
            },
          ];
          this.isSaving = false;
        })
        .catch((error) => {
          this.isSaving = false;
          this.$Progress.fail();
          this.save = "Post"
          const errCode = error?.response?.data?.error;
          const coaId = error?.response?.data?.coa_subhead_id;
          if (error?.response?.status === 422 && errCode === "INVALID_COA_SUBHEAD_ID") {
            toast.fire({
              icon: "error",
              title: "Missing COA account on one of the rows. Please select a COA.",
            });
            this.form.message = "Missing COA account on one of the rows. Please select a COA.";
            return;
          }
          if (error?.response?.status === 422 && errCode === "INVALID_DR_CR_BOTH_SET" && coaId) {
            this.invalidDrCrRowCoaSubheadId = coaId;
            const coaName =
              this.documents.find((d) => Number(d?.coa_subhead?.id) === Number(coaId))
                ?.coa_subhead?.name || "this COA";
            this.form.message = `For ${coaName}, enter either Debit OR Credit (not both).`;
            return;
          }
          const msg = error?.response?.data?.message;
          if (this.isLedgerDifferenceMessage(msg)) {
            this.setLedgerDifferenceBlockingError();
            this.form.message =
              "Ledger Difference GL is required. Create/select a COA subhead named ‘LEDGER DIFFERENCE’ or choose one in the dropdown.";
            return;
          }
          if (error?.response?.data) {
            this.form.errors = error.response.data.message;
          }
          if (msg) {
            this.form.message = msg;
          }
          // console.log(error.response.data)
        });
    },

    drDisabled(field) {
      // If credit desired balance is set, disable debit and clear it (empty string).
      if (this.hasNumericAmountEntered(field?.cr_balance_final)) {
        if (!this.isZeroOrEmpty(field?.dr_balance_final)) field.dr_balance_final = "";
        field.zeroDesired = false;
        return true;
      }
      return false;
    },
    crDisabled(field) {
      // If debit desired balance is set, disable credit and clear it (empty string).
      if (this.hasNumericAmountEntered(field?.dr_balance_final)) {
        if (!this.isZeroOrEmpty(field?.cr_balance_final)) field.cr_balance_final = "";
        field.zeroDesired = false;
        return true;
      }
      return false;
    },
    updateStatus(newStatus) {
      // console.log(newStatus);
      this.coa_desc_state = newStatus === 'accepted';
    },

    documentFile(data) {
      // console.log(data);
      this.form.receipt_name = data.name;
      this.form.receipt_location = data.path
      },
    optionsLabel({ text, value }) {
        console.log(text, value);
        return `${text}` ;
    },
    nameWithLang({ name, code, coabranch }) {
      return `${name} — ${code == undefined ? "" : code} ${coabranch?.name == undefined ? "" : coabranch?.name}`;
    },
    initialState() {
      return {
        form: {
          branch: "",
          expected_amount: "",
          amount_requested: 0,
          recorded_date: new Date().toLocaleDateString('en-CA'),
          narration: "",
          ledger_difference_coa_subhead: null,
          receipt_name: "",
          receipt_location: "",
          vouch_journ_coa_accounts: [],
              errors: [],
          journal_type: {value: 'open', text: 'Opening' },
          prev_date: "",
        },
        documents: [
          {
            dr_balance_final: "",
            cr_balance_final: "",
            differenceCents: 0,
            zeroDesired: false,
            current_balance_signed: 0,
            coa_subhead: { id: "", name: "", code: "", coahead: {} },
          },
        ],
      }
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<style>
.hideTrans{
    opacity: 0 !important;
  }
</style>